export const glsParcelShopModalRequestModalRequest = {
	init: function (resellersSearchContainer) {
		if (!resellersSearchContainer) return;
		this.resellersSearch = resellersSearchContainer;
		this.body = document.querySelector('body');
		this.modalContainer = document.querySelector('.jsModalParcelShops');
		this.modalBox = document.querySelector('.modal__box');
		this.closeBtn = document.querySelector('.modal__close-btn');
		this.searchBtn = document.querySelectorAll('.parcel-shop-selector__btn, .eco-dealer__search-btn');
		this.modalSearchFields = document.querySelectorAll('.eco-dealer__field');
		this.countryCookie = this.getCountryCookie('country');
		this.resultLabel = this.resellersSearch.querySelector('.parcel-shop-selector__selected-shop');
		this.parcelShopIdInput = document.querySelector('#parcelShopId');
		this.parcelShopNameInput = document.querySelector('#parcelShopName');
		this.parcelShopAddressInput = document.querySelector('#parcelShopAddress');
		this.parcelShopCityInput = document.querySelector('#parcelShopCity');
		this.parcelShopZipInput = document.querySelector('#parcelShopZip');
		this.postalCodeInput = document.querySelector('#postalCode');
		this.prepopulateSearchFields();
		this.assignEventListeners();
	},

	prepopulateSearchFields: function () {
		if (this.postalCodeInput) {
			[].slice.call(this.modalSearchFields).forEach((searchField) => {
				searchField.value = this.postalCodeInput.value;
			});
		}
		if (this.parcelShopNameInput) {
			if (this.resultLabel) {
				this.resultLabel.innerText = this.parcelShopNameInput.value;
			}
		}
	},

	assignEventListeners: function () {
		[].slice.call(this.searchBtn).forEach((button) => {
			button.addEventListener('click', (e) => {
				const formContainer = button.parentElement,
					input = document.querySelector('.eco-dealer__field');
				this.makeRequest(this.getInputValue(input), this.countryCookie);
			});
		});

		this.closeBtn.addEventListener('click', _ => {
			this.closeModal();
		});

		this.modalContainer.addEventListener('click', (e) => {
			this.closeModal();
		});

		[].slice.call(this.modalSearchFields).forEach((searchField) => {
			searchField.addEventListener('keypress', (e) => {
				if (e.keyCode === 13) {
					e.preventDefault();
					this.makeRequest(this.getInputValue(e.target), this.countryCookie);
				}
			});
		});

		[].slice.call(this.modalSearchFields).forEach((searchField) => {
			searchField.addEventListener('input', (e) => {
				let inputVal = e.currentTarget.value;
				e.currentTarget.value = inputVal.replace(/[^0-9]+/g, '');
			});
		});

		this.modalBox.addEventListener('click', (e) => {
			e.stopPropagation();
		});
	},


	openModal: function () {
		this.modalContainer.classList.add('modal--open');
		this.body.classList.add('modalOpen');
	},

	closeModal: function () {
		this.modalContainer.classList.remove('modal--open');
		this.body.classList.remove('modalOpen');
	},

	getInputValue: function (input) {
		[].slice.call(this.modalSearchFields).forEach((searchField) => {
			searchField.value = input.value;
		});
		return input.value;
	},

	clearInputValue: function () {
		[].slice.call(this.modalSearchFields).forEach((searchField) => {
			searchField.value = '';
		});
	},

	makeRequest: function (query, countryCookie) {
		const requestLink = "/json/getParcelShops?zipcode=" + query + "&country=" + countryCookie,
			httpRequest = new XMLHttpRequest();
		httpRequest.onload = _ => {
			this.handleResults(httpRequest);
		};
		httpRequest.open('GET', requestLink);
		httpRequest.send();
	},

	attachModalSelector: function (modalContent) {
		[].slice.call(modalContent.querySelectorAll('.resellers-modal__slide-wrapper a')).forEach((result) => {
			result.addEventListener('click', function (evt) {
				evt.stopPropagation();
			});
		});
		[].slice.call(modalContent.querySelectorAll('.resellers-modal__slide-wrapper')).forEach((result) => {
			result.addEventListener('click', function (evt) {
				if (glsParcelShopModalRequestModalRequest.resultLabel) {
					glsParcelShopModalRequestModalRequest.resultLabel.innerText = result.querySelector('h4').innerText;
					glsParcelShopModalRequestModalRequest.parcelShopIdInput.value = result.dataset.shopid;
					glsParcelShopModalRequestModalRequest.parcelShopNameInput.value = result.querySelector('h4').innerText;
					glsParcelShopModalRequestModalRequest.parcelShopAddressInput.value = result.querySelector('.resellers-modal__street').innerText;
					glsParcelShopModalRequestModalRequest.parcelShopZipInput.value = result.querySelector('.resellers-modal__zip-code').innerText;
					glsParcelShopModalRequestModalRequest.parcelShopCityInput.value = result.querySelector('.resellers-modal__city').innerText;
					const errorLabel = glsParcelShopModalRequestModalRequest.resellersSearch.querySelector('#parcelShopErrorLabel');
					if (errorLabel) {
						const errorLabelParent = errorLabel.parentNode;
						errorLabelParent.removeChild(errorLabel);
					}
					glsParcelShopModalRequestModalRequest.closeModal();
				}
			});
		});
	},

	handleResults: function (httpRequest) {
		if (httpRequest.readyState === 4) {
			if (httpRequest.status === 200) {
				const resellersModalSlider = this.resellersSearch.querySelector('.jsSwiperWrapper'),
					data = JSON.parse(httpRequest.responseText),
					template = this.resellersSearch.querySelector('#garage-template').innerHTML;
				Mustache.parse(template);
				const rendered = Mustache.render(template, data);
				resellersModalSlider.innerHTML = rendered;
				this.attachModalSelector(resellersModalSlider);
				this.openModal();
			}
		}
	},

	getCountryCookie: function (cookieKey) {
		if (!cookieKey) return null;
		return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(cookieKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
	}
}
